import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

const socialLinks = [
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Linkedin, href: "#", label: "LinkedIn" },
  { icon: Youtube, href: "#", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#0D0D0D] text-white">
      {/* Top strip */}
      <div className="w-full h-[2px] bg-gold" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand — uniform logo style */}
          <div>
            <h3
              data-testid="footer-brand"
              className="font-heading text-[22px] md:text-[26px] font-semibold tracking-tight text-white"
            >
              Giri Interiors and Constructions
            </h3>
            <p className="font-body text-sm text-white/60 mt-4 leading-relaxed max-w-xs">
              Building Dreams. Designing Spaces. Your trusted partner for
              construction and interior design in Bangalore.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-widest text-gold font-medium mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {["Services", "Portfolio", "About Us", "Contact"].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase().replace(/\s/g, "-").replace("about-us", "about")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    const id = link.toLowerCase().replace(/\s/g, "-").replace("about-us", "about");
                    document.querySelector(`#${id}`)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  data-testid={`footer-link-${link.toLowerCase().replace(/\s/g, "-")}`}
                  className="font-body text-sm text-white/60 hover:text-gold transition-colors duration-300 w-fit"
                >
                  {link}
                </a>
              ))}
            </nav>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-body text-xs uppercase tracking-widest text-gold font-medium mb-6">
              Follow Us
            </h4>
            <div className="flex gap-3" data-testid="social-links">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    data-testid={`social-${social.label.toLowerCase()}`}
                    aria-label={social.label}
                    className="w-10 h-10 border border-white/20 flex items-center justify-center text-white/60 hover:border-gold hover:text-gold transition-all duration-300"
                  >
                    <Icon size={16} strokeWidth={1.5} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">
            &copy; 2026 Giri Interiors and Constructions. All rights reserved.
          </p>
          <p
            data-testid="footer-credits"
            className="font-body text-xs text-white/40"
          >
            Developed by <span className="text-white/60">DreamB Tech</span>{" "}
            | Made with{" "}
            <a
              href="https://emergent.sh"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold hover:text-gold-light transition-colors duration-300"
            >
              EMERGENT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
